"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _recompose = require("recompose");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes"];
/*:: // 

import { type HOC } from 'recompose';*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: export type TabsProps = {
  activeTabClassName: string,
  setActiveTabIndex: (activeTabIndex: number) => mixed,
  tabClassName: string
};*/
var withTabs /*: HOC<*, Object>*/ = (0, _recompose.compose)((0, _injectSheet.default)({
  tab: {
    display: 'none'
  },
  activeTab: {
    display: 'block'
  }
}, {
  withTheme: false
}), (0, _recompose.setDisplayName)('withTabs'), (0, _recompose.withStateHandlers)(function (_ref) {
  var _ref$activeTabIndex = _ref.activeTabIndex,
    activeTabIndex = _ref$activeTabIndex === void 0 ? 0 : _ref$activeTabIndex;
  return {
    activeTabIndex: activeTabIndex
  };
}, {
  setActiveTabIndex: function setActiveTabIndex() {
    return function (activeTabIndex) {
      return {
        activeTabIndex: activeTabIndex
      };
    };
  }
}), (0, _recompose.mapProps)(function (_ref2) {
  var classes = _ref2.classes,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return _objectSpread({
    activeTabClassName: classes.activeTab,
    tabClassName: classes.tab
  }, props);
}));
var _default = exports.default = withTabs;
//# sourceMappingURL=withTabs.js.map